"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const operator_attendance_types_1 = require("./operator-attendance.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    isLoadingExportPdf: false,
    isLoadingExportExcel: false,
    documentExport: {
        content: '',
        filename: '',
        filetype: '',
    },
    dataItem: {
        id: '',
        fullname: '',
        username: '',
        location: '',
        login_time: new Date(),
        logout_time: new Date(),
        duration: ''
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'login_time', dir: 'desc' }],
        filter: {
            logic: 'and',
            filters: [
                { field: 'login_time', operator: 'eq', value: new Date(new Date().setHours(0, 0, 0, 0)) },
                { field: 'login_time', operator: 'eq', value: new Date(new Date().setHours(0, 0, 0, 0)) }
            ]
        }
    }
};
const operatorAttendanceReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [operator_attendance_types_1.operatorAttendanceTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [operator_attendance_types_1.operatorAttendanceTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates, dataGrid } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates,
            dataGrid, isLoading: false });
    },
    [operator_attendance_types_1.operatorAttendanceTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingExportPdf, isLoadingExportExcel } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isLoadingExportPdf: isLoadingExportPdf ? isLoadingExportPdf : initialState.isLoadingExportPdf, isLoadingExportExcel: isLoadingExportExcel ? isLoadingExportExcel : initialState.isLoadingExportExcel });
    },
    [operator_attendance_types_1.operatorAttendanceTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isLoadingExportPdf: false, isLoadingExportExcel: false });
    },
    [operator_attendance_types_1.operatorAttendanceTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, filter: action.payload, skip: initialState.dataStates.skip }) });
    },
    [operator_attendance_types_1.operatorAttendanceTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [operator_attendance_types_1.operatorAttendanceTypes.SET_EXPORT_DOCUMENTS_URL]: (state, action) => {
        const { name, type, content } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoadingExportPdf: false, isLoadingExportExcel: false, documentExport: {
                content: content,
                filename: name,
                filetype: type,
            } });
    },
    [operator_attendance_types_1.operatorAttendanceTypes.CLEAR_EXPORT_DOCUMENTS_URL]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, documentExport: {
                content: '',
                filename: '',
                filetype: '',
            } });
    }
});
exports.default = operatorAttendanceReducer;
